/**
 * Canonical timestamp helper for any value persisted server-side.
 *
 * Returns a UTC ISO-8601 string with millisecond precision and a
 * trailing `Z` — e.g. `"2026-05-22T18:43:12.345Z"` — matching the
 * format the backend's `edge_user_api.commons.now_iso()` produces.
 *
 * Use this everywhere we stamp `updatedAt`, `createdAt`, `deletedAt`,
 * `lastUsedAt`, or any other timestamp that goes back to the server.
 * `Date.toISOString()` already happens to produce this exact format,
 * so the helper is a thin wrapper — its real value is centralization
 * (one place to change if we ever migrate to a different precision).
 *
 * Do NOT use this for purely-local timestamps (e.g. IndexedDB epoch
 * fields used numerically); `Date.now()` is fine there.
 */
export const nowIso = (): string => new Date().toISOString()
